import React from 'react';
import '../App.css';

function ContractorDetailModal({ isOpen, onClose, contractor, onEdit, onDelete }) {
  if (!isOpen || !contractor) return null;

  const handleDelete = () => {
    onDelete(contractor.id);
    onClose(); // 삭제 후 모달 닫기
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button">×</button>
        <h2>시공사 상세 정보</h2>
        <div className="detail-item">
          <strong>시공사명:</strong> {contractor.name}
        </div>
        <div className="detail-item">
          <strong>주소:</strong> {contractor.address}
        </div>
        <div className="detail-item">
          <strong>대표:</strong> {contractor.representative}
        </div>
        <div className="detail-item">
          <strong>비고:</strong>
          <textarea
            value={contractor.remarks || ''}
            readOnly
            rows="4"
            style={{ width: '100%', minHeight: '100px', border: '1px solid #ccc', borderRadius: '4px', padding: '8px' }}
          />
        </div>
        {/* <div className="form-actions">
          <button onClick={() => onEdit(contractor)} className="action-button edit-button">수정</button>
          <button onClick={handleDelete} className="action-button delete-button">삭제</button>
        </div> */}
      </div>
    </div>
  );
}

export default ContractorDetailModal;
